import { getSubscriptionAdditionalData } from '@sxm-de/dev-kits/web-sdk/domains/subscriptions-core';
import {
    DomainInitPayload,
    Subscription,
} from '@sxm-de/dev-kits/web-sdk/types';
import {
    getOfferDetails,
    getOffersCommerceInfo,
} from '@sxm-de/dev-kits/web-sdk/domains/offers';
import { getSubscription } from '../helpers/get-subscription';

interface GetSubscriptionDetailsWithOfferDetailsFnPayload {
    subscriptionId: string;
}

export type GetSubscriptionDetailsWithOfferDetailsFn = (
    payload: GetSubscriptionDetailsWithOfferDetailsFnPayload,
) => Promise<{
    subscription: Subscription;
    offersCommerceInfo: {
        locales: {
            [locale: string]: any[];
        };
    };
    offerDetails: unknown;
}>;

// TODO: determine if we even need this anymore since we are not currently calling it
export function initGetSubscriptionDetailsWithOfferDetailsFn({
    dependencies,
    countryCodeDefault,
    locale,
}: DomainInitPayload): GetSubscriptionDetailsWithOfferDetailsFn {
    return async ({ subscriptionId }) => {
        try {
            const subscription = await getSubscription(
                { subscriptionId },
                dependencies,
            );

            const { detailedState } = await getSubscriptionAdditionalData(
                {
                    subscription,
                },
                dependencies,
            );
            const offerIds = [
                ...new Set([
                    subscription.offerId,
                    ...(subscription.offers.active
                        ? [subscription.offers.active.id]
                        : []),
                    ...(subscription.offers.pending
                        ? [subscription.offers.pending.id]
                        : []),
                ]),
            ];
            const offersCommerceInfo = await getOffersCommerceInfo(
                {
                    offerIds,
                    countryCode: countryCodeDefault,
                    locale,
                },
                dependencies,
            );
            const offerDetails = await getOfferDetails(
                {
                    offerId: subscription.offerId,
                },
                dependencies,
            );

            return {
                subscription: {
                    ...subscription,
                    detailedState,
                },
                offersCommerceInfo,
                offerDetails,
            };
        } catch (error: any) {
            // TODO: handle error scenarios like 404 vs a System error
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
